<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	// Design system components
	import { AdvancedCard, ActionsContainer, IconButton } from '@Shelly/shelly-design-system';
	//Helpers
	import { format_temp_units } from 'src/helpers/utilities';
	import { getTimeFormat } from 'src/helpers/date_helper';
	//Components
	import WeekDaysSelected from 'src/components/TimePicker/WeekDaysSelected.svelte';
	//Types
	import type { TempScheduleInterval } from 'src/types/TemperatureSchemeType';
	import { format } from 'svelte-i18n';

	export let interval: TempScheduleInterval,
		units: string,
		withControls = false;

	const dispatch = createEventDispatcher();
	const avatar = { icon: 'fat fa-calendar' };
	const subtitle = {
		value: `${getTimeFormat.apply(
			interval.time,
			interval.time[0].split(':'),
		)} - ${getTimeFormat.apply(interval.time, interval.time[1].split(':'))}`,
		bold: false,
		textSmall: false,
	};
	const selection = interval.days;
	const description = {
		value: interval.disabled
			? $format('disabled', {
					default: 'disabled',
				})
			: interval.base + format_temp_units(units),
		textSmall: false,
	};
</script>

{#if withControls}
	<AdvancedCard title="Interval" {avatar} {subtitle} {description}>
		<WeekDaysSelected {selection} slot="title" />
		<ActionsContainer orientation="vertical" type="simple" slot="right">
			<IconButton
				aria-label={$format('button_edit_interval', { default: 'Button Edit interval' })}
				icon="fas fa-pen"
				slot="first"
				on:click={() => dispatch('edit')}
			/>
			<IconButton
				aria-label={$format('button_delete_interval', { default: 'Button Delete interval' })}
				icon="fas fa-trash"
				variant="danger"
				slot="second"
				on:click={() => dispatch('delete')}
			/>
		</ActionsContainer>
	</AdvancedCard>
{:else}
	<AdvancedCard title="Interval" {avatar} {subtitle} {description}>
		<WeekDaysSelected {selection} slot="title" />
	</AdvancedCard>
{/if}
